import { render, staticRenderFns } from "./chart-wrapper.vue?vue&type=template&id=4c05ba7e&scoped=true"
import script from "./chart-wrapper.vue?vue&type=script&lang=js"
export * from "./chart-wrapper.vue?vue&type=script&lang=js"
import style0 from "./chart-wrapper.vue?vue&type=style&index=0&id=4c05ba7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c05ba7e",
  null
  
)

export default component.exports